import { render, staticRenderFns } from "./PlanPartnerList.vue?vue&type=template&id=31e7634d&scoped=true&"
import script from "./PlanPartnerList.vue?vue&type=script&lang=js&"
export * from "./PlanPartnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7634d",
  null
  
)

export default component.exports